import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../../../utilities/hooks/UseDictionary';
import ExperiencePoiItem from './ExperiencePoiItem';
import {useHistory} from 'react-router-dom'
import { NavigatorPaths } from '../../../../../../../../assets/dictionaries/NavigatorPaths';

const ExperiencePOIs = ({details}) => {
    const dictionary  = useDictionary();
    const history = useHistory();

    const onPointOfInterestClicked = (pointOfInterestItem) => {
        history.push(`/${NavigatorPaths.point_of_interests.path}/${pointOfInterestItem.id}`);
    }
    
    return (
        <div className="detail-tab-container thin-scrollbar fade-on-load">
            <div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '16px' }}
			>
				<h3>
					{dictionary.point_of_interests}
				</h3>
			</div>
            {
                (details?.point_of_interests && details.point_of_interests.length > 0) ? (
                    <table style={{ marginLeft: -8, borderCollapse: "collapse", width:"100%" }} className='provider-customer-booking-listing'>
                        <tbody>
                            {details.point_of_interests.map(item => (
                                <ExperiencePoiItem
                                    key={item.id}
                                    onItemCLicked={() => onPointOfInterestClicked(item)}
                                    pointOfInterest={item}
                                />
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="empty-provider-customers-list-placeholder d-flex-center">
                        <div className="empty-provider-customers-image empty-provider-customers-details-image"/>
                        <h3
                            data-testid="no-bookings-yet-header"
                            className='empty-provider-customers-title'
                        >
                            {dictionary.point_of_interests_empty_message}
                        </h3>
                        <div className="text empty-provider-customers-message">
                            {dictionary.point_of_interests_empty_description}
                        </div>
                    </div>
                )
            }
        </div>
    )
}

ExperiencePOIs.propTypes = {
    details: PropTypes.object
};

export default ExperiencePOIs;